export default "__VITE_ASSET__2ed10cf7__"